import React, { useEffect } from 'react';

export default function SummaryScheduleTable(props) {
    useEffect(() => {
        window.initializeTooltips({
            template: `<div id="tooltip" class="popover tw-flex-col tw-gap-y-2 tw-bg-blue tw-p-2.5 tw-rounded-lg tw-border-0 tw-hidden" role="tooltip">
            <h3 class="popover-header tw-p-0 tw-text-xs tw-text-white tw-font-bold tw-border-0 tw-bg-transparent before:!tw-hidden"></h3>
            <div class="popover-body tw-p-0 tw-text-xs tw-text-white tw-font-medium"></div>
        </div>`,
        });
    }, []);

    return (
        <div className="inbud-table_wrapper tw-w-full tw-relative tw-overflow-x-scroll tw-border-2 tw-border-grey tw-rounded-lg tw-text-charcoal tw-text-sm tw-overflow-y-auto tw-max-h-screen">
            <table className="tw-w-full tw-table-fixed tw-border-collapse">
                <thead className="tw-font-semibold tw-sticky tw-top-0" style={{ zIndex: '15' }}>
                    <tr>
                        {props.headings.map((col, key) => {
                            const thClasses =
                                key === 0
                                    ? 'tw-w-56 tw-sticky tw-left-0 tw-h-fit tw-p-4 tw-bg-blue-25'
                                    : key === 1
                                      ? 'tw-w-56 tw-sticky tw-left-56 tw-h-fit tw-p-4 tw-bg-blue-25'
                                      : 'tw-w-36 tw-p-4 tw-bg-blue-25';

                            return (
                                <th key={`heading-${key}`} className={thClasses}>
                                    {col}
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {props.data.map((row, rowKey) => {
                        if ('venue' in row) {
                            return (
                                <tr key={`row-${rowKey}`} className="tw-border-b-2 last:tw-border-0 tw-border-grey tw-bg-grey/50">
                                    {Object.keys(row).map((colKey) => {
                                        const col = row[colKey];
                                        if (!('venue' in props.data[rowKey - 1]) || colKey !== 'venue') {
                                            const colClass =
                                                colKey === 'venue'
                                                    ? 'tw-w-56 tw-sticky tw-left-0 tw-h-fit tw-text-blue tw-font-semibold tw-bg-white tw-z-10 tw-align-top tw-p-4 tw-border-r-2 last:tw-border-r-0 tw-relative'
                                                    : colKey === 'sport'
                                                      ? 'tw-w-56 tw-sticky tw-left-56 tw-h-fit tw-text-blue tw-font-semibold tw-bg-white tw-z-10 tw-p-4 tw-border-r-2 last:tw-border-r-0 tw-relative'
                                                      : 'tw-w-36 tw-p-4 tw-border-r-2 last:tw-border-r-0 tw-relative';
                                            const rowSpan = colKey === 'venue' ? col.sports_count : 1;
                                            const content = _.isObject(col) && col.content ? col.content : '';

                                            return (
                                                <td key={`row-${rowKey}-col-${colKey}`} className={colClass} rowSpan={rowSpan}>
                                                    {colKey === 'venue' && <a href={props.venueUrls[rowKey]}>{col.name}</a>}
                                                    {colKey === 'sport' && <a href={props.sportUrls[rowKey]}>{col}</a>}
                                                    {colKey !== 'venue' && colKey !== 'sport' && _.isObject(col) && (
                                                        <div
                                                            data-popper-toggle="tooltip"
                                                            data-trigger="hover"
                                                            data-placement="bottom"
                                                            data-html="true"
                                                            data-content={col['tooltip']}
                                                            data-type="popover"
                                                            data-title={col['title']}
                                                        >
                                                            <div className="tw-flex tw-items-center tw-gap-x-2">
                                                                {Array((content.match(/\*/g) || []).length)
                                                                    .fill('')
                                                                    .map((val, i) => {
                                                                        if (col.is_medal && col.medal_indexes.includes(i)) {
                                                                            return (
                                                                                <img
                                                                                    key={`medal-${i}`}
                                                                                    src={'/images/event-info/gold.svg'}
                                                                                    className="tw-w-6 tw-h-6"
                                                                                />
                                                                            );
                                                                        } else {
                                                                            return (
                                                                                <img
                                                                                    key={`star-${i}`}
                                                                                    src={'/images/event-info/star.svg'}
                                                                                    className="tw-w-2.5 tw-h-2.5"
                                                                                />
                                                                            );
                                                                        }
                                                                    })}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {colKey !== 'venue' && colKey !== 'sport' && !_.isObject(col) && <>{col}</>}
                                                </td>
                                            );
                                        }
                                    })}
                                </tr>
                            );
                        } else {
                            return (
                                <tr key={`row-${rowKey}`} className="tw-border-b-2 last:tw-border-0 tw-border-grey tw-bg-grey/50">
                                    {Object.keys(row).map((colKey) => {
                                        const col = row[colKey];
                                        const colClass =
                                            colKey === 'venue'
                                                ? 'tw-w-56 tw-sticky tw-left-0 tw-h-fit tw-bg-white tw-z-10'
                                                : colKey === 'sport'
                                                  ? 'tw-w-56 tw-sticky tw-left-56 tw-h-fit tw-bg-white tw-z-10'
                                                  : 'tw-p-0';

                                        return (
                                            <td key={`row-${rowKey}-col-${colKey}`} className={colClass}>
                                                {col}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        }
                    })}
                </tbody>
            </table>
        </div>
    );
}
